import React, { useState } from 'react'
import { useAdminAuth } from '../contexts/AdminAuthContext'
import { Card, CardHeader, CardTitle, CardContent, Input, Button, Alert } from '../components'

// Only this account is allowed into the admin dashboard — checked
// client-side only, the backend still gates on ADMIN_PASSWORD alone.
const ADMIN_USERNAME = 'superuser@conveyo.one'

export const AdminLogin: React.FC = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const { login } = useAdminAuth()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (!username || !password) {
      setError('Please enter your username and password')
      return
    }

    if (username.trim().toLowerCase() !== ADMIN_USERNAME) {
      setError('Invalid username or password')
      setPassword('')
      return
    }

    const success = await login(password)
    if (!success) {
      setError('Invalid username or password')
      setPassword('')
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <div className="flex items-center gap-2 mb-6">
        <img src="/conveyo/logo.svg" alt="Conveyo Logo" className="w-10 h-10" />
        <h1 className="logo">
          <span className="logo-conveyo">conveyo</span>
          <span className="logo-dot">.</span>
          <span className="logo-one">one</span>
        </h1>
      </div>
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-center">Admin Login</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="text"
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter admin username"
              autoFocus
            />

            <Input
              type="password"
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              error={error}
            />

            {error && (
              <Alert type="error">
                {error}
              </Alert>
            )}

            <Button type="submit" className="w-full" size="lg">
              Log In
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
